// eslint-disable-next-line no-control-regex
const CONTROL_CHARS_REGEX = /[\u0000-\u001F\u007F]/g
const DANGEROUS_HTML_CHARS_REGEX = /[<>`]/g
const MULTI_SPACE_REGEX = /\s+/g

const sanitizeRawText = (value: string): string =>
  value.replaceAll(CONTROL_CHARS_REGEX, '').replaceAll(DANGEROUS_HTML_CHARS_REGEX, '')

export const sanitizeBrowserText = (value: string, maxLength = 160): string =>
  sanitizeRawText(value).replaceAll(MULTI_SPACE_REGEX, ' ').trim().slice(0, maxLength)

export const sanitizeBrowserIdentifier = (value: string, maxLength = 64): string =>
  sanitizeRawText(value).replace(MULTI_SPACE_REGEX, '').trim().slice(0, maxLength)
